import { Button, Divider, Input, makeStyles, Text, tokens } from '@fluentui/react-components';
import { AddFilled, ArrowDownloadFilled, PersonLockFilled, PulseFilled, SearchFilled } from "@fluentui/react-icons";
import React from 'react';
import { useIntl } from 'react-intl';

const useStyles = makeStyles({
  container: {
    justifyContent: "space-between",
    height: "42px",
    background: tokens.colorNeutralBackground3,
    display: "flex",
  },
  wrapper: {
    display: "flex",
    padding: "0px 12px",
    alignItems: "center",
  },
  text: {
    color: tokens.colorNeutralForeground1,
    padding: "0px 12px"
  }
});

const AppListTableHeader: React.FC<{
  length: number;
  isTenantAdmin: boolean;
  isMicrosoft: boolean;
  newDialogOpen: (value: boolean) => void;
  importDialogOpen: (value: boolean) => void;
  ownerDialogOpen: (value: boolean) => void;
  onAppsFilter: (str: string) => void
  firstPartyPublishingStatus: (value: boolean) => void;
  setFirstPartyImportCatalog: (value: boolean) => void;
}> = ({ length, isTenantAdmin, isMicrosoft, newDialogOpen, onAppsFilter, importDialogOpen, ownerDialogOpen, firstPartyPublishingStatus, setFirstPartyImportCatalog }) => {
  const classes = useStyles();
  const intl = useIntl();
  const handleAppsFilter = (event: React.ChangeEvent<HTMLInputElement>) => {
    const value = event.target.value;
    onAppsFilter(value);
  };
  return (
    <div className={classes.container}>
      <div className={classes.wrapper}>
        <Button
          appearance='transparent'
          icon={<AddFilled />}
          onClick={() => newDialogOpen(true)}
        >
          {intl.formatMessage({ defaultMessage: "New App" })}
        </Button>
        <Button
          appearance='transparent'
          icon={<ArrowDownloadFilled />}
          onClick={() => importDialogOpen(true)}
        >
          {intl.formatMessage({ defaultMessage: "Import app" })}
        </Button>
        {(isTenantAdmin) &&
          <Button appearance='transparent'
            icon={<PersonLockFilled />}
            onClick={() => ownerDialogOpen(true)}
          >
            {intl.formatMessage({ defaultMessage: "Take ownership" })}
          </Button>
        }
        {(isMicrosoft) &&
          <Button appearance='transparent'
            onClick={() => setFirstPartyImportCatalog(true)}
            icon={<ArrowDownloadFilled />}>
            {intl.formatMessage({ defaultMessage: "Import from catalog" })}
          </Button>
        }
        {isMicrosoft &&
          <Button appearance='transparent'
            onClick={() => firstPartyPublishingStatus(true)}
            icon={<PulseFilled />}
          >
            {intl.formatMessage({ defaultMessage: "App publishing status" })}
          </Button>
        }
        <Divider style={{ maxWidth: "12px" }} vertical />
        <Text className={classes.text}>
          {`${length} items`}
        </Text>
      </div>
      <div className={classes.wrapper}>
        <Input
          appearance='filled-lighter'
          placeholder={intl.formatMessage({ defaultMessage: "Search app" })}
          contentAfter={<SearchFilled />}
          onChange={handleAppsFilter}
        />
      </div>
    </div>
  );
};

export default AppListTableHeader;
